import classnames from 'classnames';
import React from 'react';
import { Field, useField } from 'react-final-form';

import { RadioInput } from '../../../../interfaces';
import { useFormInput } from '../../../../libs/hooks';
import { InputMessageComponent } from '../../input-message';

export const RadioInputComponent: React.FC<RadioInput> = React.memo((props: RadioInput) => {
  const {
    choices,
    className,
    description,
    disabled,
    label,
    name,
    required = true,
    validators,
  } = props;

  const { id, texts, validate } = useFormInput({
    description,
    disabled,
    label,
    name,
    required,
    validators,
  });

  const metaField = useField(id, { subscription: { error: true, touched: true } });
  const error = metaField.meta.touched && metaField.meta.error;

  return (
    <fieldset
      aria-labelledby={`${id}-legend ${id}-messages`}
      className={classnames('fr-fieldset fr-mb-2w', className, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'fr-fieldset--error': !!error,
      })}
      id={id}>
      <legend
        className="fr-fieldset__legend--regular fr-fieldset__legend fr-h6"
        id={`${id}-legend`}>
        {texts.label}
        {texts.hint && (
          <span
            className={classnames('fr-hint-text fc-text--no-bold', {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              'fc-text--title-disabled-grey': disabled,
            })}>
            {texts.hint}
          </span>
        )}
      </legend>
      {choices.map(({ label: choiceLabel, value }) => (
        <div key={value} className="fr-fieldset__element fr-fieldset__element--inline">
          <div className="fr-radio-group">
            <Field
              component="input"
              id={`${id}-${value}`}
              name={id}
              required={required}
              type="radio"
              validate={validate}
              value={value}
            />
            <label className="fr-label" htmlFor={`${id}-${value}`}>
              {choiceLabel}
            </label>
          </div>
        </div>
      ))}
      <InputMessageComponent error={error} id={id} />
    </fieldset>
  );
});

RadioInputComponent.displayName = 'RadioInputComponent';
